<div id="layout" class="theme-cyan">
  <app-chat-leftmenu></app-chat-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3" id="show-user-detail">

    <!-- chat body -->
    <div class="chat-body">

      <!-- Chat: Header -->
      <div class="chat-header border-bottom py-xl-4 py-md-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- Chat photo -->
            <div class="col-6 col-xl-4">
              <div class="media">
                <div class="me-3 show-user-detail" (click)="slidechat()">
                  <span class="status rounded-circle"></span>
                  <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                  </div>
                  <div class="text-truncate">online</div>
                </div>
              </div>
            </div>

            <!-- Chat toolbar -->
            <div class="col-6 col-xl-8 text-end">

              <ul class="nav justify-content-end">
                <li class="nav-item list-inline-item d-none d-md-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-sm-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="videocam">
                    <i class="zmdi zmdi-videocam zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-sm-block me-3">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="Call">
                    <i class="zmdi zmdi-phone-forwarded zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item add-user-btn">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" title="Add Account"
                    (click)="slideuserchat()">
                    <i class="zmdi zmdi-account-add zmdi-hc-lg"></i>
                  </a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">Search chat</a>
                      <a class="dropdown-item" href="javascript:void(0)">Attache Image</a>
                      <a class="dropdown-item" href="javascript:void(0)">Video call</a>
                      <a class="dropdown-item" href="javascript:void(0)">Call</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add New</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Chat: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="d-flex justify-content-center align-items-center h-100 text-center py-xl-4 py-md-3 py-2">
        <div class="container-fluid">

          <div class="avatar lg avatar-bg me-auto ms-auto mb-5">
            <div class="avatar lg rounded-circle no-image">
              <span><i class="zmdi zmdi-mic zmdi-hc-2x"></i></span>
            </div>
            <span class="a-bg-1"></span>
            <span class="a-bg-2"></span>
          </div>

          <!-- Action btn -->
          <div class="mt-5">

            <button type="submit" class="btn btn-default" data-bs-toggle="tooltip" title="Mute">
              <i class="zmdi zmdi-mic-off"></i>
            </button>

            <button type="submit" class="btn btn-default" data-bs-toggle="tooltip" title="Call Recording">
              <i class="zmdi zmdi-dot-circle"></i>
            </button>

            <button type="submit" class="btn btn-danger" data-bs-toggle="tooltip" title="End cll">
              <i class="zmdi zmdi-phone"></i>
            </button>

            <button type="submit" class="btn btn-default" data-bs-toggle="tooltip" title="Screen Share">
              <i class="zmdi zmdi-desktop-mac"></i>
            </button>

            <button type="submit" class="btn btn-default" data-bs-toggle="tooltip" title="Chat Sidebar">
              <i class="zmdi zmdi-comments"></i>
            </button>

          </div>
        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

    <!-- Chat: user details -->
    <div class="user-detail-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">User Details</h6>
            <span class="text-muted">Update your profile details</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button" (click)="closechatside()"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body mt-4">
          <div class="d-flex justify-content-center">
            <div class="avatar xxl">
              <img class="avatar xxl rounded-circle" src="../assets/images/sm/avatar2.jpg" alt="avatar">
            </div>
          </div>
          <div class="text-center mt-3 mb-5">
            <h4>Jason Porter</h4>
            <span class="text-muted">michelle.green@gmail.com</span>
            <p>+14 123 456 789 - New york (USA)</p>
          </div>

          <!-- Chat: mutual friend list -->
          <ul class="chat-list">
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>mutual friend</span>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Michelle Green</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 258</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar2.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Jason Porter</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 963</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Elizabeth Martin</h6>
                      </div>
                      <div class="text-truncate">+14 123 456 753</div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>
      </div>
    </div>

    <!-- Chat: add new user to create a group chat -->
    <div class="addnew-user-sidebar py-xl-4 py-3 px-xl-4 px-3">
      <div class="d-flex flex-column">
        <div class="header border-bottom pb-4 d-flex justify-content-between">
          <div>
            <h6 class="mb-0 fw-bold">Add new member</h6>
            <span class="text-muted">Update your profile details</span>
          </div>
          <div>
            <button class="btn btn-link text-muted close-chat-sidebar" type="button" (click)="closeuserchatside()"><i
                class="zmdi zmdi-close"></i></button>
          </div>
        </div>

        <div class="body mt-4">

          <!-- Chat: user search -->
          <div class="form-group input-group-lg search mb-3">
            <i class="zmdi zmdi-search"></i>
            <input type="text" class="form-control" placeholder="Search...">
          </div>

          <!-- Chat: user list -->
          <ul class="chat-list">
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>A</span>
              <div class="dropdown">
                <a class="btn btn-link px-1 py-0 border-0 text-muted dropdown-toggle" href="javascript:void(0)"
                  role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" href="javascript:void(0)">Action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                  <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                </div>
              </div>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar1.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Amelia Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar3.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Ava Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 1 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>C</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charlotte Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar5.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Chloe Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 3 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar6.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Charles Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 2 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>D</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar4.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">David Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>M</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Michael Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar8.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Mohammad</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
            <li class="header d-flex justify-content-between ps-3 pe-3 mb-1">
              <span>T</span>
            </li>
            <li>
              <div class="hover_action">
                <button type="button" class="btn btn-link text-info"><i class="zmdi zmdi-plus-circle"></i></button>
              </div>
              <a href="javascript:void(0)" class="card">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <img class="avatar rounded-circle" src="../assets/images/xs/avatar9.jpg" alt="avatar">
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">Tommy Green</h6>
                      </div>
                      <div class="text-truncate">
                        last seen 6 hours ago
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>
  <!-- Main Body: Content -->
</div>
